<template>
  <!-- 联系我们弹框 -->
  <div class="version-update-dialog">
    <!--  -->
    <el-dialog
      title="提示"
      top="30vh"
      :visible="show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="472px"
    >
      <div class="main">
        <div class="main-header">
          <div class="main-title">扫码添加企业微信</div>
          <!-- <i class="el-icon-close main-close-icon" @click="closeDialog"></i> -->
          <div class="main-close-icon" @click="closeDialog"></div>
        </div>
        <div class="main-list">
          <div class="main-item" v-if="customerInfo.SalesQrCode">
            <div class="main-item-title">专属销售</div>
            <div class="main-item-name">{{ customerInfo.SalesName }}</div>
            <div class="main-item-code">
              <img
                :src="customerInfo.SalesQrCode"
                alt="code"
                width="148"
                height="148"
              />
            </div>
            <div class="main-item-phone" v-if="customerInfo.SalesMobile">
              <div
                class="main-item-phone__inner"
                @click="copyToClipboard(customerInfo.SalesMobile)"
              >
                <div class="main-item-phone__icon"></div>
                <div class="main-item-phone__text">
                  {{ customerInfo.SalesMobile }}
                </div>
              </div>
              <div class="main-item-phone__tip"></div>
            </div>
          </div>
          <div class="main-item" v-if="customerInfo.KFQrCode">
            <div class="main-item-title1">专属客服</div>
            <div class="main-item-name">{{ customerInfo.KFName }}</div>
            <div class="main-item-code">
              <img
                :src="customerInfo.KFQrCode"
                alt="code"
                width="148"
                height="148"
              />
            </div>
            <div class="main-item-phone" v-if="customerInfo.KFMobile">
              <div
                class="main-item-phone__inner"
                @click="copyToClipboard(customerInfo.KFMobile)"
              >
                <div class="main-item-phone__icon"></div>
                <div class="main-item-phone__text">
                  {{ customerInfo.KFMobile }}
                </div>
              </div>
              <div class="main-item-phone__tip"></div>
            </div>
          </div>
        </div>
        <!-- <div class="reload-btn" @click="reloadPage"></div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAccountInfo } from '@/util/util';
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      customerInfo: {
        SalesName: '',
        SalesMobile: '',
        SalesQrCode: '',
        KFName: '',
        KFMobile: '',
        KFQrCode: '',
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  async mounted() {
    this.customerInfo = await getAccountInfo(this, 1);
    console.log(this.customerInfo, 11111);
  },
  methods: {
    closeDialog() {
      // this.$store.commit('user/SET_VERSION', false);
      this.$emit('close', false);
    },
    reloadPage() {
      this.closeDialog();
      this.$router.go(0);
    },

    copyToClipboard(text) {
      var textarea = document.createElement('textarea');
      textarea.style.position = 'fixed';
      textarea.style.opacity = 0;
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../common/css/common';
.version-update-dialog {
  background: transparent;

  & /deep/ .el-dialog {
    background: transparent;
    box-shadow: none;
  }
  & /deep/ .el-dialog__header {
    padding: 0 !important;
    display: none !important;
  }

  & /deep/ .el-dialog__footer {
    padding: 0 !important;
  }

  & /deep/ .el-dialog__body {
    background: transparent;
    padding: 0 !important;
  }

  .main {
    // position: relative;
    width: 472px;
    height: 356px;
    background: url('../../static/newStatic/img/leftFixedIcon/pic_bg_qw_all@2x.png');
    background-size: 472px 356px;
    box-sizing: border-box;

    .main-header {
      height: 56px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      .main-title {
        display: inline-block;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        text-align: left;
        font-style: normal;
      }
      .main-close-icon {
        width: 16px;
        height: 16px;
        background: url('../../static/newStatic/img/leftFixedIcon/ic_close_default@2x.png')
          no-repeat;
        background-size: 16px 16px;
        &:hover {
          cursor: pointer;
          width: 16px;
          height: 16px;
          background: url('../../static/newStatic/img/leftFixedIcon/ic_close_hover@2x.png')
            no-repeat;
          background-size: 16px 16px;
        }

        &:active {
          cursor: pointer;
          width: 16px;
          height: 16px;
          background: url('../../static/newStatic/img/leftFixedIcon/ic_close_click@2x.png')
            no-repeat;
          background-size: 16px 16px;
        }
      }
    }

    .main-list {
      padding: 0 40px;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      .main-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        &:nth-child(2) {
          margin-left: 56px;
        }

        .main-item-title {
          padding: 4px 8px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: #0046b9;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          background: rgba(0, 70, 185, 0.08);
          border-radius: 8px;
          box-sizing: border-box;
        }

        .main-item-title1 {
          padding: 4px 8px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: #4d1ed9;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          background: rgba(77, 30, 217, 0.08);
          border-radius: 8px;
          box-sizing: border-box;
        }

        .main-item-name {
          margin-top: 8px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 13px;
          color: #333333;
          line-height: 20px;
          text-align: center;
          font-style: normal;
        }

        .main-item-code {
          margin-top: 12px;
          width: 168px;
          height: 168px;
          padding: 10px;
          background: #ffffff;
          border-radius: 12px;
          border: 1px solid rgba(32, 109, 234, 0.16);
          box-sizing: border-box;
        }

        .main-item-phone {
          position: relative;
          margin-top: 16px;
          .main-item-phone__inner {
            display: flex;
            justify-content: center;
            align-items: center;
            .main-item-phone__icon {
              width: 16px;
              height: 16px;
              background: url('../../static/newStatic/img/leftFixedIcon/ic_tel_default@2x.png');
              background-size: 16px 16px;
              translate: all 0.3s;
            }

            .main-item-phone__text {
              margin-left: 8px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 13px;
              color: #333333;
              line-height: 18px;
              text-align: left;
              font-style: normal;
              translate: all 0.3s;
            }

            &:hover {
              cursor: pointer;
              .main-item-phone__icon {
                width: 16px;
                height: 16px;
                background: url('../../static/newStatic/img/leftFixedIcon/ic_tel_hover@2x.png');
                background-size: 16px 16px;
              }
              .main-item-phone__text {
                color: #0046b9;
              }
            }
          }

          .main-item-phone__tip {
            position: absolute;
            opacity: 0;
            width: 112px;
            height: 32px;
            background: url('../../static/newStatic/img/leftFixedIcon/phoneTip.png');
            background-size: 112px 32px;
            visibility: hidden;
            transition: all 0.3s;
          }

          &:hover {
            .main-item-phone__tip {
              opacity: 1;
              visibility: visible;
            }
          }
        }
      }
    }

    .main-text {
      margin-top: 23px;
      padding: 0 24px;
      box-sizing: border-box;

      .main-text-title {
        font-size: 18px;
        font-family: AlibabaPuHuiTiM;
        color: #333333;
        line-height: 32px;
      }

      .main-text-info {
        margin-top: 4px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 18px;
      }
    }

    .reload-btn {
      margin: 12px 8px 2px 8px;
      width: 232px;
      height: 72px;
      cursor: pointer;
      background: url('../../static/newStatic/img/indexPage/立即刷新-默认@2x.png');
      background-size: 232px 72px;
      box-sizing: border-box;
      transition: background 0.2s;
      &:hover {
        background: url('../../static/newStatic/img/indexPage/立即刷新-悬停@2x.png');
        background-size: 232px 72px;
      }

      &:active {
        background: url('../../static/newStatic/img/indexPage/立即刷新-点击@2x.png');
        background-size: 232px 72px;
      }
    }
  }
}

.version-update-dialog /deep/ .el-dialog__wrapper {
  display: flex;
  align-items: center;

  .el-dialog {
    margin-top: 0 !important;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConnectDialog.vue